import authAxios from 'src/modules/shared/axios/authAxios';

/** API de administración por tenant (superadmin); `tenantId` es el tenant gestionado. */
export default class TenantAdminApi {
  static divisionsList(tenantId: string, params?: any) {
    return authAxios.get(`/tenant/${tenantId}/division`, { params });
  }

  static divisionCreate(tenantId: string, data: any) {
    return authAxios.post(`/tenant/${tenantId}/division`, { data });
  }

  static divisionUpdate(tenantId: string, id: string, data: any) {
    return authAxios.put(`/tenant/${tenantId}/division/${id}`, { id, data });
  }

  static divisionDestroy(tenantId: string, ids: string[]) {
    return authAxios.delete(`/tenant/${tenantId}/division`, { params: { ids } });
  }

  static customRolesList(tenantId: string, params?: any) {
    return authAxios.get(`/tenant/${tenantId}/tenant-custom-role`, { params });
  }

  static customRoleFind(tenantId: string, id: string) {
    return authAxios.get(`/tenant/${tenantId}/tenant-custom-role/${id}`);
  }

  static customRoleCreate(tenantId: string, data: any) {
    return authAxios.post(`/tenant/${tenantId}/tenant-custom-role`, { data });
  }

  static customRoleUpdate(tenantId: string, id: string, data: any) {
    return authAxios.put(`/tenant/${tenantId}/tenant-custom-role`, {
      id,
      data,
    });
  }

  static customRoleDestroy(tenantId: string, ids: string[]) {
    return authAxios.delete(`/tenant/${tenantId}/tenant-custom-role`, {
      params: { ids },
    });
  }

  static customRoleDuplicate(tenantId: string, sourceId: string, name: string) {
    return authAxios.post(`/tenant/${tenantId}/tenant-custom-role/duplicate`, {
      sourceId,
      name,
    });
  }

  static customRolePermissionCatalog(tenantId: string) {
    return authAxios.get(
      `/tenant/${tenantId}/tenant-custom-role/permission-catalog`,
    );
  }

  static customRoleUsers(tenantId: string, roleId: string) {
    return authAxios.get(
      `/tenant/${tenantId}/tenant-custom-role/${roleId}/users`,
    );
  }

  static authTenantContext(tenantId: string) {
    return authAxios.get(`/tenant/${tenantId}/auth/tenant-context`);
  }

  /** Usuarios del tenant gestionado (no usa el tenant activo de sesión). */
  static userAutocomplete(
    tenantId: string,
    query: any,
    limit = 30,
    opts?: { ignoreDivisionScope?: boolean },
  ) {
    return authAxios.get(`/tenant/${tenantId}/user/autocomplete`, {
      params: {
        query,
        limit,
        ...(opts?.ignoreDivisionScope ? { ignoreDivisionScope: true } : {}),
      },
    });
  }

  static userFind(tenantId: string, userId: string) {
    return authAxios.get(`/tenant/${tenantId}/user/${userId}`);
  }

  static userEdit(tenantId: string, data: any) {
    return authAxios.put(`/tenant/${tenantId}/user`, { data });
  }
}
